import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=0b70c13a&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=0b70c13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70c13a",
  null
  
)

export default component.exports